import { shallowRef } from 'vue';

export interface FeatureTriggerOptions {
	title: string;
	description: string;
	onTrigger: () => void | Promise<void>;
}

export interface FeatureTrigger extends FeatureTriggerOptions {
	id: string;
}

const featureTriggers = shallowRef<FeatureTrigger[]>([]);

export function defineFeatureTrigger(id: string, options: FeatureTriggerOptions): FeatureTrigger {
	const featureTrigger = {
		id,
		...options,
	};

	featureTriggers.value = [...featureTriggers.value.filter((trigger) => trigger.id !== id), featureTrigger];

	return featureTrigger;
}

export function useRegisteredFeatureTriggers() {
	return featureTriggers;
}

export function resetFeatureTriggersForTesting() {
	featureTriggers.value = [];
}
